import axios from "axios";

import { SPA_BACKEND_URL } from "./localSettings";

const getBaseUrl = () => {
  // Local dev defaults to localhost:8001; production builds set this to the
  // ZX backend URL (e.g., https://zxdata.zanbato.com/).
  return SPA_BACKEND_URL;
};

const AxiosInstance = axios.create({
  baseURL: getBaseUrl(),
  responseType: "json",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
});

export default AxiosInstance;
